import { Component, Inject, OnInit } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss'],
})
export class DashboardComponent implements OnInit {
  constructor(
    @Inject(DOCUMENT) private document: any,
    private sanitizer: DomSanitizer
  ) {}

  cookie: any;

  urlIframe: SafeResourceUrl = '';
  url: string = '';

  ngOnInit(): void {
    this.url =
      this.document.location.hostname == 'localhost'
        ? this.document.location.hostname + ':4200/other/dashboardIframe'
        : this.document.location.hostname + '/other/dashboardIframe';
    console.log(this.sanitizer.bypassSecurityTrustResourceUrl(this.url));
    this.urlIframe = this.sanitizer.bypassSecurityTrustResourceUrl("https://vpc-elasticsearch-dev-zwzsd24pptwzk2fttmmnnjlhaa.us-east-1.es.amazonaws.com/_dashboards/app/dashboards?security_tenant=global#/view/e40d0ca0-f262-11ec-aba5-49390515a6bb?embed=true&_g=(filters%3A!()%2CrefreshInterval%3A(pause%3A!t%2Cvalue%3A0)%2Ctime%3A(from%3Anow-15m%2Cto%3Anow))");
  }
}
